export const REBUZZ_SORT_OPTIONS = [
  'cost',
  'numberSubscribers',
  'threadLength',
  'queueSpeed',
];

export const REBUZZ_SORT_OPTIONS_ORDER = ['lowToHigh', 'highToLow'];
